import React from "react";
import { FaEuroSign, FaRegClock, FaRegCheckCircle, FaCarSide, FaRegHandshake, FaRegSmile, FaFile } from "react-icons/fa";
import { slugify } from '@/lib/slugify';

interface Advantage {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const advantages: Advantage[] = [
  {
    icon: <FaRegHandshake className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Kompetenter Service & beste Ankaufspreise",
    description: "Wir kaufen Fahrzeuge aller Art und stehen für kompetenten Service, beste Ankaufspreise und eine verlässliche Abwicklung.",
  },
  {
    icon: <FaEuroSign className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Schnelle Zahlung",
    description: "Das Fahrzeug wird bei der Übergabe vor Ort entweder per Überweisung oder bar bezahlt.",
  },
  {
    icon: <FaRegClock className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Einfache Abwicklung",
    description: "Der Verkauf Ihres Fahrzeugs kann innerhalb von 24 Stunden vonstattengehen.",
  },
  {
    icon: <FaRegCheckCircle className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Kostenlose Abmeldung",
    description: "Wir melden das Fahrzeug nach dem KFZ-Ankauf kostenfrei bei der Zulassungsstelle ab.",
  },
  {
    icon: <FaCarSide className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Abholung vor Ort",
    description: "Wir holen Ihr Auto kostenfrei und unabhängig vom Zustand an Ihrem Wunschort ab.",
  },
  {
    icon: <FaRegSmile className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Zufriedene Kunden",
    description: "Viele positive Rückmeldungen bestätigen unseren zuverlässigen und freundlichen Service.",
  },
    {
    icon: <FaFile className="text-white bg-primary rounded-full p-2 w-10 h-10" />,
    title: "Verwertungnachweis",
    description: "Wir stellen Ihnen einen offiziellen Verwertungnachweis für Ihr Fahrzeug aus.",
  },
];

interface AdvantageComponentProps {
  sectionId?: string;
}

const AdvantageComponent: React.FC<AdvantageComponentProps> = ({ sectionId }) => {
  const id = sectionId || slugify('Ihre Vorteile: Schrottauto verkaufen kann sich lohnen');

  return (
    <section id={id} className="py-12 bg-primary/10">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-dark mb-10 text-center">
          <a href={`#${id}`} className="group inline-flex items-center gap-2 hover:text-primary-dark justify-center">
            Ihre Vorteile: Schrottauto verkaufen kann sich lohnen
            <span className="text-primary-dark opacity-0 transition-opacity duration-200 group-hover:opacity-100">#</span>
          </a>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((adv, idx) => (
            <div key={idx} className="flex flex-col items-center text-center bg-white rounded-2xl shadow-md p-6 transition hover:shadow-lg animate-fadeIn">
              <div className="mb-4">{adv.icon}</div>
              <h3 className="text-lg font-semibold text-primary-dark mb-2">{adv.title}</h3>
              <p className="text-gray-700 text-base leading-relaxed">{adv.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantageComponent;
